// extracted by mini-css-extract-plugin
module.exports = {"v1dysi9p":"v1dysi9p"};